export const countryCodeOptions = [
    { label: "New Zealand (+64)", value: "+64" },
    { label: "Australia (+61)", value: "+61" },
    { label: "India (+91)", value: "+91" },
    { label: "Nepal (+977)", value: "+977" },
    { label: "Sri Lanka (+94)", value: "+94" },
    { label: "Pakistan (+92)", value: "+92" },
    { label: "Bangladesh (+880)", value: "+880" },
    { label: "Philippines (+63)", value: "+63" },
    { label: "Singapore (+65)", value: "+65" },
    { label: "Malaysia (+60)", value: "+60" },
    { label: "United Kingdom (+44)", value: "+44" },
    { label: "Ireland (+353)", value: "+353" },
    { label: "United States (+1)", value: "+1" },
    { label: "Canada (+1)", value: "+1 " },
    { label: "United Arab Emirates (+971)", value: "+971" },
    { label: "Saudi Arabia (+966)", value: "+966" },
    { label: "Qatar (+974)", value: "+974" },
    { label: "Kuwait (+965)", value: "+965" },
    { label: "Bahrain (+973)", value: "+973" },
    { label: "Oman (+968)", value: "+968" },
    { label: "South Africa (+27)", value: "+27" },
    { label: "Nigeria (+234)", value: "+234" },
    { label: "Kenya (+254)", value: "+254" },
    { label: "Zimbabwe (+263)", value: "+263" },
    { label: "Fiji (+679)", value: "+679" },
    { label: "China (+86)", value: "+86" },
    { label: "Japan (+81)", value: "+81" },
    { label: "South Korea (+82)", value: "+82" },
    { label: "Indonesia (+62)", value: "+62" },
    { label: "Thailand (+66)", value: "+66" },
    { label: "Vietnam (+84)", value: "+84" },
    { label: "Germany (+49)", value: "+49" },
    { label: "France (+33)", value: "+33" },
    { label: "Spain (+34)", value: "+34" },
    { label: "Italy (+39)", value: "+39" },
    { label: "Netherlands (+31)", value: "+31" },
    { label: "Brazil (+55)", value: "+55" },
];

export const workedCountryOptions = [
    "India",
    "Nepal",
    "Sri Lanka",
    "Pakistan",
    "GCC Countries",
    "UK",
    "Ireland",
    "USA",
    "Canada",
    "Singapore",
    "Philippines",
    "Others",
];

export const experienceOptions = [
    { label: "1 Year", value: "1 Year" },
    { label: "2 Years", value: "2 Years" },
    { label: "3 Years", value: "3 Years" },
    { label: "4 Years", value: "4 Years" },
    { label: "5 Years", value: "5 Years" },
    { label: "More than 5 Years", value: "More than 5 Years" },
];

export const departmentOptions = [
    { label: "Emergency Department", value: "Emergency Department" },
    { label: "Operation Theatre", value: "Operation Theatre" },
    { label: "Intensive Care Unit (Adult)", value: "Intensive Care Unit (Adult)" },
    { label: "Intensive Care Unit (Pediatric)", value: "Intensive Care Unit (Pediatric)" },
    { label: "Intensive Care Unit (Neonatal)", value: "Intensive Care Unit (Neonatal)" },
    { label: "Medical/Surgical Wards", value: "Medical/Surgical Wards" },
    { label: "Mental Health", value: "Mental Health" },
    { label: "Maternity & Newborn Care", value: "Maternity & Newborn Care" },
    { label: "Dialysis", value: "Dialysis" },
    { label: "Oncology & Palliative Care", value: "Oncology & Palliative Care" },
];

export const visaStatusOptions = [
    { label: "Visit Visa", value: "Visit Visa" },
    { label: "Dependent Visa", value: "Dependent Visa" },
    { label: "Work Visa", value: "Work Visa" },
    { label: "PR", value: "PR" },
    { label: "Citizen", value: "Citizen" },
];

export const yesNoOptions = [
    { label: "Yes", value: "Yes" },
    { label: "No", value: "No" },
];
